import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "RentalMarineRequest" })
export default class RentalMarineRequest extends Vue {
    public isLoading: boolean = false;
    public nullValue: any = null;

    public provinces: any[] = [];
    public dealerPoints: any[] = [];
    public showSkipperSelector: boolean = false;
    public showNotFound: boolean = false;

    public selectedProvince: string = "";
    public selectedDealerPoint: any = null;
    public rentalServiceData: any[] = [];
    public rentRequestSubmit: any = { type: null, isSkipper: null };
    public isSuccess: boolean = false;
    public isExternalRentalService: boolean = false;
    public isDealerRentalService: boolean = false;

    public privacyPolicy: string = null;
    public isPrivacyPolicyShown: boolean = false;

    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    @Prop() readonly recaptchaSiteKey: string;

    @Watch("rentRequestSubmit.type") onTypeChanged(value: any, oldValue: any) {
        this.provinces = [];
        this.selectedProvince = null;
        this.selectedDealerPoint = null;
        this.rentRequestSubmit.isSkipper = null;
        this.showNotFound = false;

        if (value !== "WaveRunner") {
            this.showSkipperSelector = true;

            if (this.rentRequestSubmit.isSkipper) {
                this.$store.dispatch("rentalMarineStore/getProvinces", { boatType: this.rentRequestSubmit.type, isSkipper: this.rentRequestSubmit.isSkipper }).then((response) => {
                    this.provinces = response.data.provinces;

                    if (this.provinces.length === 0) {
                        this.showNotFound = true;
                    }
                });
            }
        } else {
            this.showSkipperSelector = false;

            this.$store.dispatch("rentalMarineStore/getProvinces", { boatType: this.rentRequestSubmit.type }).then((response) => {
                this.provinces = response.data.provinces;

                if (this.provinces.length === 0) {
                    this.showNotFound = true;
                }
            });
        }
    }

    @Watch("rentRequestSubmit.isSkipper") onIsSkipperChanged(value: boolean) {
        this.provinces = [];
        this.selectedProvince = null;
        this.selectedDealerPoint = null;
        this.showNotFound = false;

        this.$store.dispatch("rentalMarineStore/getProvinces", { boatType: this.rentRequestSubmit.type, isSkipper: this.rentRequestSubmit.isSkipper }).then((response) => {
            this.provinces = response.data.provinces;
            if (this.provinces.length === 0) {
                this.showNotFound = true;
            }
        });
    }

    public created() {
        this.$store.dispatch("rentalMarineStore/getPrivacyPolicy").then((response) => {
            this.privacyPolicy = response.data.privacyPolicy.Text;
        });
    }

    public profiling(profiling: boolean) {
        this.rentRequestSubmit.isProfiling = profiling;
    }

    public marketing(marketing: boolean) {
        this.rentRequestSubmit.isMarketing = marketing;
    }

    public marketingChannels(marketingChannels: any) {
        this.rentRequestSubmit.marketingChannels = marketingChannels;
    }

    public async selectProvince() {
        this.isLoading = true;
        this.selectedDealerPoint = null;
        this.rentalServiceData = null;

        const response = await Axios.post(this.routes.RentalMarine_GetDealerPoints, { boatType: this.rentRequestSubmit.type, isSkipper: this.rentRequestSubmit.isSkipper, province: this.selectedProvince });
        if (response) {
            this.dealerPoints = response.data.dealerPoints;
            this.isLoading = false;
        }
    }

    public async selectDealerPoint() {
        this.isLoading = true;
        this.rentalServiceData = null;

        if (this.selectedDealerPoint) {
            let response = await this.$store.dispatch("rentalMarineStore/getRentalServiceData", { dealerPointCode: this.selectedDealerPoint.Code });
            if (response) {
                this.rentalServiceData = response.data.rentalServiceData;
                this.isExternalRentalService = response.data.isExternalRentalService;
                this.isDealerRentalService = response.data.isDealerRentalService;
                this.isLoading = false;
            }
        }
    }

    public async submitRentRequest() {
        FormHelper.removeFocus();
        this.validationErrors = [];

        this.rentRequestSubmit.dealerPointCode = this.selectedDealerPoint.code;
        (<any>window).grecaptcha.enterprise.ready(async () => {
            const token = await (<any>window).grecaptcha.enterprise.execute(this.recaptchaSiteKey, { action: 'Submit' });

            try {
                let response = await Axios.post(this.routes.RentalMarine_Request, this.rentRequestSubmit, { headers: { "RecaptchaVerificationToken": token } });
                if (response && response.status === 200) {
                    if (response.data.state) {
                        for (let errorField of response.data.state) {
                            for (let message of errorField.errors) {
                                this.validationErrors.push({ message: message });
                            }
                        }

                    } else {
                        this.isSuccess = true;
                    }
                }
            } catch (error) {
                if (error.response && error.response.status === 400) {
                    this.validationErrors = FormHelper.getValidationErrors(error.response.data);
                }
            }
        });
    }

    public async showPrivacyPolicy() {
        this.isPrivacyPolicyShown = !this.isPrivacyPolicyShown;
    }
}